import { render, staticRenderFns } from "./Testimonials.vue?vue&type=template&id=f45f71b0&scoped=true"
import script from "./Testimonials.vue?vue&type=script&lang=js"
export * from "./Testimonials.vue?vue&type=script&lang=js"
import style0 from "./Testimonials.vue?vue&type=style&index=0&id=f45f71b0&prod&lang=scss"
import style1 from "./Testimonials.vue?vue&type=style&index=1&id=f45f71b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f45f71b0",
  null
  
)

export default component.exports